<form action="" class="form">
  <div class="grid">
    <div class="col-6">
      <div class="field mb-4">
        <label for="">{{ "ADMIN.PATIENTS.METADATA.TYPE" | translate }}</label>
        <div class="p-fluid">
          <p-select
            name="type"
            size="small"
            [options]="this.metadataTypes"
            [optionLabel]="'name'"
            [(ngModel)]="this.metadataType"
            fluid
          ></p-select>
        </div>
      </div>

      <div [ngSwitch]="(this.metadataType || {}).id">
        <div *ngSwitchCase="1">
          <app-create-metadata-option></app-create-metadata-option>
        </div>
        <div *ngSwitchCase="2">
          <app-create-metadata-text></app-create-metadata-text>
        </div>

        <div *ngSwitchCase="6">
          <app-create-metadata-boolean></app-create-metadata-boolean>
        </div>
      </div>
    </div>
  </div>
</form>
